import { Table, message } from "antd";
import { debounce } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import apiCall from "../../../components/Api";
import FilterOptions from "../../../components/Common/antdFilterOptions";
import StatusComponent from "../../../components/Common/StatusComponent";
import Deletepopup from "../../../components/Modal/AntdDeletepopup";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import Pagination from "../../../components/Common/CommonPagination/index";
import MainconternLayout from "../../../components/Layout/MainconternLayout";
import { viewMedbreadcrumbsList } from "../Const";

const SaltMoleculeMedicines = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [pages, setPages] = useState(0);
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(10);
  const [records, setRecords] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [deleteModal, setDeleteModal] = useState({ id: "", status: false });
  const [searchText, setSearchText] = useState("");
  const [molecule, setMolecule] = useState([]);

  useEffect(() => {
    list_api_call();
  }, [limit, searchText]);

  const handleEdit = (id) => {
    navigate(`/healthsy-services/order-medicines/edit-medicine/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const res = await apiCall(`medicine/delete/${id}`, "DELETE", null, null);
      list_api_call();
      setDeleteModal({ id: "", status: false });
      message.success(`${res.data?.medicine_name} deleted successfully`);
    } catch (error) {
      setDeleteModal({ id: "", status: false });
      message.error("Failed to delete item");
    }
  };

  const handleClose = () => {
    setDeleteModal({ id: "", status: false });
  };

  const handleActive = async (id, status) => {
    try {
      await apiCall(`medicine/update/${id}`, "PATCH", {
        medicine_url_status: !status,
      });

      list_api_call();
    } catch (err) {
      console.error(err);
    }
  };

  const list_api_call = async () => {
    try {
      const response = await apiCall(`medicine/list`, "POST", {
        limit: Number(limit),
        searchText,
        saltMolecule: id,
      });
      const totalCount = response.data.count;
      setRecords(response.data);
      setMolecule(response.data?.saltMolecule?.molecule_name);
      setPages(Math.ceil(totalCount / limit));
    } catch (err) {
      console.error(err);
      alert("Some error occurred while fetching filter options");
    }
  };

  const handlePageChange = (event) => {
    setSkip(event.selected * limit);
  };

  const debouncedSearch = debounce((value) => {
    handlePageChange({ selected: 0 });
    setSearchText(value);
  }, 500);

  const onChangeSearch = (value) => {
    debouncedSearch(value);
  };

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) => skip + (index + 1),
      key: "serial",
      width: 80,
    },
    {
      title: "Status & Actions",
      render: (text, record) => (
        <StatusComponent
          text={text}
          record={record}
          showPopup={showPopup}
          setShowPopup={setShowPopup}
          handleEdit={handleEdit}
          setDeleteModal={setDeleteModal}
          handleActive={handleActive}
          title={""}
          active="medicine_url_status"
        />
      ),
      key: "actions",
      width: 170,
    },
    {
      title: "Medicines",
      dataIndex: "medicines",
      key: "medicine",
      width: 200,
      render: (text, record) => (
        <span className="">{record.medicine_name}</span>
      ),
    },
  ];

  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex pb-2 flex-wrap align-items-center justify-content-between">
            <Breadcrumbs
              className="healthsyMasterBreadCrumbs"
              breadcrumbsList={viewMedbreadcrumbsList(molecule)}
            />
          </div>
        }
        footer={
          <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
            <div className="border border-danger bg-bg-light px-2 py-1 rounded">
              {" "}
              Total Medicines: {records.count}
            </div>
            {records.count >= limit && (
              <Pagination
                skip={skip}
                limit={limit}
                total={pages * limit}
                onPageChange={(selected) => handlePageChange({ selected })}
              />
            )}
          </div>
        }
      >
        <FilterOptions
          title="viewMed"
          limit={limit}
          setLimit={setLimit}
          onChangeSearch={onChangeSearch}
        />
        <Table
          columns={columns}
          dataSource={records?.rows}
          pagination={false}
          rowKey="_id"
          className="mx-3 pt-2 table-scrollable viewMed_table"
          scroll={{ x: "max-content" }}
        />
      </MainconternLayout>
      {deleteModal.status === true && (
        <Deletepopup
          handleDelete={handleDelete}
          id={deleteModal?.id}
          isCloseModalEnable={true}
          handleClose={handleClose}
        />
      )}
    </>
  );
};

export default SaltMoleculeMedicines;
